import React from 'react';
import { Box, Typography, CircularProgress, Alert, Container } from '@mui/material';
import { tosApi } from '../../store/tos/tos.api';

export const Terms: React.FC = () => {
  const { data: latestTos, isLoading, error } = tosApi.useGetLatestTosVersionQuery();

  if (isLoading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 15 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ mt: 15 }}>
        <Alert severity="error">
          Failed to load Terms of Service. Please try again later.
        </Alert>
      </Container>
    );
  }

  if (!latestTos) {
    return (
      <Container maxWidth="lg" sx={{ mt: 15 }}>
        <Alert severity="info">
          No Terms of Service found.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 15 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Terms of Service
      </Typography>
      
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Version {latestTos.version} - {new Date(latestTos.timestamp).toLocaleDateString()}
      </Typography>

      <Box 
        mt={3}
        dangerouslySetInnerHTML={{ __html: latestTos.content }}
        sx={{
          '& h1, & h2, & h3, & h4, & h5, & h6': {
            marginTop: 2,
            marginBottom: 1,
          },
          '& p': {
            marginBottom: 1,
          },
          '& ul, & ol': {
            marginBottom: 1,
            paddingLeft: 2,
          },
          '& li': {
            marginBottom: 0.5,
          },
        }}
      />
    </Container>
  );
};

export default Terms;
